module.exports = __webpack_public_path__ + "media/images/landing_page/2023/tools/png/budget_en-d17eab3b0630fbe14579cb65c9ab29a4.png";